import { FunctionComponent, memo } from 'react';
import {
  EventItemUnavailable,
  HorizontalStoryFeedCardProps,
  HorizontalStoryFeedContentCommon,
  useIsEventUnavailable,
} from '../../../../shared';
import { HorizontalStoryFeedAdminCardWrapper } from '../HorizontalStoryFeedAdminCardWrapper';

export const HorizontalStoryFeedAdminEvent: FunctionComponent<HorizontalStoryFeedCardProps> = memo(
  ({ card }) => {
    const isEventUnavailable = useIsEventUnavailable();

    const { isPinnedToTopOfNewsFeed, isPinnedToTopOfStory, event } = card;

    if (isEventUnavailable(event)) {
      return (
        <HorizontalStoryFeedAdminCardWrapper card={card}>
          <EventItemUnavailable />
        </HorizontalStoryFeedAdminCardWrapper>
      );
    }

    if (!event) {
      return null;
    }

    return (
      <HorizontalStoryFeedAdminCardWrapper card={card}>
        <HorizontalStoryFeedContentCommon
          isPinnedToTopOfNewsFeed={isPinnedToTopOfNewsFeed}
          isPinnedToTopOfStory={isPinnedToTopOfStory}
          title={event.name}
          htmlText={event.descriptionHTML}
        />
      </HorizontalStoryFeedAdminCardWrapper>
    );
  }
);
